import { render } from "./CertificateSite.vue?vue&type=template&id=4cf90320"
import script from "./CertificateSite.vue?vue&type=script&lang=js"
export * from "./CertificateSite.vue?vue&type=script&lang=js"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__